<template lang="pug">
main
  v-container.pa-0.mt-2(fill-height fluid grid-list-md)
    v-layout(wrap)
      v-flex(xs12)
        v-card.py-2(flat)
          v-card-title.pt-2.pb-0.dashboard-title
            .text
              v-icon.mr-2(color='grey') fab fa-wpforms
              h3.body-2.grey--text.my-0
                span(v-if='dashboard') {{ $tc('thePeriod', +dashboard.period, { n: dashboard.period }) }}
                | {{ $t('registrationOverview') }}
                v-btn(small flat icon @click='fetch' :loading='isFetching' v-if='isDebugMode'): v-icon refresh
            v-tooltip(bottom)
              v-btn(icon small @click='toLatestForm()' slot='activator'): v-icon fas fa-angle-right
              span(v-t='"allForms"')

          v-card-text.py-1
            Dashboard(:dashboard='dashboard')
      v-flex(xs6 sm4 md3 v-for='key in Object.keys(shortcutLists).sort((a, b) => a - b)' :key='key')
        v-layout(wrap)
          v-flex(xs12 v-for='(i, index) in shortcutLists[key]' :key='index')
            v-card(flat ripple :to='getShortcutTo(i.name)')
              v-card-text.item
                v-icon {{ i.icon }}
                div
                  .font-weight-bold {{ $t(i.caption) }}
                  .caption(v-if='i.description') {{ i.description }}

  .mt-3.grey--text(@dblclick='toggleDebugMode()')
    small {{ build }}
</template>

<script>
import apis from '@/assets/js/apis'
import Loader from '@/components/Loader.vue'
import Dashboard from '@/components/home/Dashboard.vue'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(localizedFormat)

export default {
  name: 'home',
  metaInfo () {
    return {
      title: this.$t('概覽'),
    }
  },
  data () {
    return {
      dashboard: null,
      error: null,
      isFetching: false,
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    // 是否在首頁不顯示某些捷徑按鈕
    isCardBtnShow (name) {
      return ['home', 'form', 'config', 'groupConfig', 'account'].every(v => name !== v)
    },
    getShortcutTo (name) {
      const period = this.$store.getters.currentPeriod

      if (name === 'lottery') return { name, params: { period } }
      return { name }
    },
    async fetch () {
      this.isFetching = true
      try {
        this.dashboard = await apis.dashboard.get({}, this.token)
        this.isFetching = false
      } catch (e) {
        this.error = e
        this.isFetching = false
      }
    },
  },
  computed: {
    schoolName () {
      return this.$store.getters.schoolName
    },
    cover () {
      return this.$store.getters.cover
    },
    shortcutLists () {
      const col1 = this.navbarItems.filter(_ => {
        return !_.isDivider && !_.isSubheader && ['home', 'form', 'config', 'groupConfig', 'account'].every(v => _.name !== v)
      })
      const col2 = this.navbarItems.filter(_ => {
        return !_.isDivider && !_.isSubheader && ['config', 'groupConfig'].some(v => _.name === v)
      })
      return { col1, col2 }
    },
    build () {
      const formattedDate = dayjs(process.env.BUILT_AT).format('LLL')
      const commitHash = process.env.COMMIT_HASH

      return `build: ${commitHash} (${formattedDate})`
    },
  },
  components: {
    Loader,
    Dashboard,
  },
}
</script>

<style scoped lang="sass">
h1
  font-size: 2rem
  margin-bottom: 0

.item
  display: flex
  .v-icon
    font-size: 1.8rem
    min-width: 3.2rem

.dashboard-title
  display: flex
  justify-content: space-between
  .text
    display: flex
    align-items: center
</style>

<i18n src="@/lang/views/home.json"></i18n>
